import { createContext } from 'react';

import type { FrontpageError } from '../utils/frontpage-error';

interface ErrorContextType {
  error: FrontpageError | undefined;
  setError(error: FrontpageError | undefined): void;
}

export const ErrorContext = createContext<ErrorContextType>({
  error: undefined,
  setError: () => {}
});

export const ErrorProvider = ErrorContext.Provider;
